import { configureStore } from "@reduxjs/toolkit";
import configSlice from "./slices/userDataStore";
import orderReducer from './orderSlice/OrderSlice'

const appStore = configureStore({
  reducer: {
    config: configSlice,
    order: orderReducer,
  },
});

export default appStore;
